<div class="main-content">
    <div class="container-fluid">
        <div class="clearfix"></div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
<!--                     <div class="card-header card/-header-primary card-header-icon">
                        <div class="card-icon">
                            <i class="material-icons">assignment</i>
                        </div>
                        <h4 class="card-title">Log's List</h4>
                    </div> -->
                    <div class="card-body">
                       
                            <!--        Here you can write extra buttons/actions for the toolbar              -->
                        
<!--                          <div class="material-datatables">
                            <table id="datatables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>

                                        <th>Company</th>
                                        <th>{{ dataTable.headerRow[1] }}</th>
                                        <th>{{ dataTable.headerRow[2] }}</th>
                                        <th>{{ dataTable.headerRow[3] }}</th>
                                        <th class="d-none" style="display: none">{{ dataTable.headerRow[4] }}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr id="user{{row[0]}}" *ngFor="let row of dataTable.dataRows">
                                        <td>{{row[5]}}</td>
                                        <td>{{row[1]}}</td>
                                        <td>{{row[2] | titlecase}}</td>
                                        <td>{{row[3] | date: 'medium'}}</td>
                                        <td class="d-none" style="display: none">{{row[4]}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>  -->
                        <div *ngIf="loading" style="text-align: center">
                            <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
                          </div>
                          
                        <dinamic-table
                        *ngIf="!loading"
                        [id]="'LogTable'"
                        [dbname]="'LogsTable'"
                        [frontpaginate]="false"
                        [data]="dataTable"
                        [config]="options"
                        [perPage]="itemsPorPagina"
                        [page]="paginaActual"
                        [total_items_count]="totalItems"
                        [total_pages]="totalPaginas"
                        (newConfig)="updateConfig($event)"
                        [columnfilters]="filtros"
                        (buscar)="getAllLogs($event)"
                        (rightClickAction)="handleRightClick($event)" 
                    ></dinamic-table>
                    </div>
                    <!-- end content-->
                </div>
                <!--  end card  -->
            </div>
            <!-- end col-md-12 -->
        </div>
        <!-- end row -->
    </div>
</div>